export default "__VITE_ASSET__Bh19ns7d__"